import {manager} from "../weather/weather_manager";
import {is_authenticated} from "../settings/settings_common";

function getRectangles(selector) {
    const elements = document.querySelectorAll(selector);
    return Array.from(elements).map(element => {
        const rect = element.getBoundingClientRect();
        return {
            x: Math.round(rect.left),
            y: Math.round(rect.top)+1,
            width: Math.round(rect.width),
            height: Math.round(rect.height)
        };
    });
}

const auth_url = `https://zima-backend.farawaytech.com/v1/images/blur`;
const default_url = `https://zima-backend.farawaytech.com/v1/images/default_blur`;


async function setBackgroundImage(url, brightness, cur_temp) {
    const cards = getRectangles('.container, #calendar, #navigation_extra.content, #horoscope.content');
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const payload = JSON.stringify({
        rectangles: cards,
        screenWidth,
        screenHeight,
        brightness,
        cur_temp
    });
    const sky = document.getElementById("sky");
    const horizonNight = document.getElementById("darknessOverlaySky");

    try {
        const urlParams = new URLSearchParams(window.location.search);
        let headers = {'Content-Type': 'application/json'};
        if (urlParams.has("token")) {
            headers["ZIMA-AUTH-TOKEN"] = urlParams.get("token")
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            credentials: 'include',
            body: payload,
        });
        if (response.ok) {
            const data = await response.json();
            sky.style.removeProperty("background-image");
            sky.style.backgroundImage = `url(${data.image})`;
            sky.style.backgroundSize = "cover";
            horizonNight.style.removeProperty("background-image");
            horizonNight.style.backgroundImage = `url(${data.image})`;
            horizonNight.style.backgroundSize = "cover";

            // add attribution
            //document.getElementById("attribution_text").innerHTML = `Photo by ${data.name} on <a href="https://unsplash.com/?utm_source=zima-weather&utm_medium=referral">Unsplash</a>`;

            // if creating new image
            // const img = document.createElement('img');
            // img.src = url;
            // document.body.appendChild(img);
        }
    } catch (error) {
        console.error('Error:', error);
    }
}


export async function applyBackgroundImage() {
    if (!manager.currentWeather) {
        // when user does not have weather credits anymore
        return;
    }
    await new Promise(r => setTimeout(r, 1000));
    if (is_authenticated) {
        await setBackgroundImage(auth_url, manager.brightness, manager.currentWeather.temp);
    } else {
        await setBackgroundImage(default_url, manager.brightness, manager.currentWeather.temp);
    }
}